import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { API_URL_SET_SELECTED_ACCOUNT } from "../../../../../constants";
import { RootState } from "../../../../../models";
import * as Ajax from "../../../app/Ajax";
import * as AT from "../actionTypes";

export const setSelectedAccount =
    (accountId: string | null): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        dispatch({
            type: AT.CHECKOUT_SET_SELECTED_ACCOUNT,
            payload: Ajax.post(
                {
                    url: API_URL_SET_SELECTED_ACCOUNT,
                    data: { accountId },
                },
                dispatch,
            ),
        });
    };
